import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-026bd6c8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "com-div"
};

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div data-v-026bd6c8><a href=\"https://github.com/gobysec\" target=\"_blank\" data-v-026bd6c8><i class=\"iconfont icongit- index-i\" data-v-026bd6c8></i></a><a href=\"https://x.com/GobySec\" target=\"_blank\" data-v-026bd6c8><i class=\"iconfont icontter- index-i\" data-v-026bd6c8></i></a><a href=\"http://t.me/gobies\" target=\"_blank\" data-v-026bd6c8><i class=\"iconfont icontelegram index-i\" data-v-026bd6c8></i></a><a href=\"mailto:gobysec@gmail.com\" target=\"_blank\" data-v-026bd6c8><i class=\"iconfont icongmail- index-i\" data-v-026bd6c8></i></a></div>", 1);

const _hoisted_4 = {
  key: 0,
  href: "https://beian.miit.gov.cn/",
  target: "_blank",
  class: "beian"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", null, [_ctx.lang == 'zh' ? (_openBlock(), _createElementBlock("a", _hoisted_4, "京ICP备2022017714号-1")) : _createCommentVNode("", true), _hoisted_5, _createElementVNode("span", null, "©" + _toDisplayString(new Date().getFullYear()) + " Goby", 1)])])]);
}